import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import React from "react";


function OurProductSlider() {
    const settings = {
        infinite: true,
        dots: false,
        arrows:true,
        slidesToShow: 4,
        slidesToScroll: 1,
        lazyLoad: true,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
                infinite: true,
                dots: true
              }
            },
            {
                breakpoint: 992,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  dots: true
                }
              },
            {
                breakpoint: 767,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false
              }
            }
          ]
    };
  return (
    <>
    <section className="section-padding">
        <div className="container-fluid">
            <div className="section-header">
                <h3 className="title">OUR PRODUCTS</h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur.</p>
            </div>
            <Slider {...settings}>
                <div className="slide-item col-12">
                    <div className="product_block">
                        <div className="sale">
                            Sale
                        </div>
                        <div className="product_image">
                            <Link to="/shop-details">
                                <img src="/tm/react/toolways/assets/images/product/vegetables/13.png" className="image-fit-contain" alt="img"/>
                            </Link>
                            <ul className="social">
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-eye" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-cart-plus" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-cube" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fal fa-heart" aria-hidden="true"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <h4 className="title"><Link to="/shop-details">Cutter Power Tools</Link></h4>
                        <div className="price">
                            <span>$55.00</span>
                            <span>$80.25</span>
                        </div>
                        <div className="star-ratings">
                            <ul className="rating">
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star-half" aria-hidden="true"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star-half" aria-hidden="true"></i>
                                </li>
                            </ul>
                        </div>
                        <div className="product_action">
                            <button type="button" className="product_btn">ADD <i className="fal fa-plus"></i></button>
                        </div>
                    </div>
                </div>
                <div className="slide-item col-12">
                    <div className="product_block">
                        <div className="product_image">
                            <Link to="/shop-details">
                                <img src="/tm/react/toolways/assets/images/product/vegetables/14.png" className="image-fit-contain" alt="img"/>
                            </Link>
                            <ul className="social">
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-eye" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-cart-plus" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-cube" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fal fa-heart" aria-hidden="true"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <h4 className="title"><Link to="/shop-details">Consectetur adipiscing</Link></h4>
                        <div className="price">
                            <span>$55.00</span>
                            <span>$80.25</span>
                        </div>
                        <div className="star-ratings">
                            <ul className="rating">
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star-half" aria-hidden="true"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star-half" aria-hidden="true"></i>
                                </li>
                            </ul>
                        </div>
                        <div className="product_action">
                            <button type="button" className="product_btn">ADD <i className="fal fa-plus"></i></button>
                        </div>
                    </div>
                </div>
                <div className="slide-item col-12">
                    <div className="product_block">
                        <div className="sale">
                            Sale
                        </div>
                        <div className="product_image">
                            <Link to="/shop-details">
                                <img src="/tm/react/toolways/assets/images/product/vegetables/15.png" className="image-fit-contain" alt="img"/>
                            </Link>
                            <ul className="social">
                                <li>
                                    <Link to="">
                                        <i className="fa fa-eye" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-cart-plus" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-cube" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="">
                                        <i className="fal fa-heart" aria-hidden="true"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <h4 className="title"><Link to="/shop-details">Rockwell Ultimate Gardening Bundle</Link></h4>
                        <div className="price">
                            <span>$55.00</span>
                            <span>$80.25</span>
                        </div>
                        <div className="star-ratings">
                            <ul className="rating">
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star-half" aria-hidden="true"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star-half" aria-hidden="true"></i>
                                </li>
                            </ul>
                        </div>
                        <div className="product_action">
                            <button type="button" className="product_btn">ADD <i className="fal fa-plus"></i></button>
                        </div>
                    </div>
                </div>
                <div className="slide-item col-12">
                    <div className="product_block">
                        <div className="product_image">
                            <Link to="/shop-details">
                                <img src="/tm/react/toolways/assets/images/product/vegetables/16.png" className="image-fit-contain" alt="img"/>
                            </Link>
                            <ul className="social">
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-eye" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-cart-plus" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-cube" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fal fa-heart" aria-hidden="true"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <h4 className="title"><Link to="/shop-details">Suspendisse Hand Tools</Link></h4>
                        <div className="price">
                            <span>$55.00</span>
                            <span>$80.25</span>
                        </div>
                        <div className="star-ratings">
                            <ul className="rating">
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star-half" aria-hidden="true"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star-half" aria-hidden="true"></i>
                                </li>
                            </ul>
                        </div>
                        <div className="product_action">
                            <button type="button" className="product_btn">ADD <i className="fal fa-plus"></i></button>
                        </div>
                    </div>
                </div>
                <div className="slide-item col-12">
                    <div className="product_block">
                        <div className="sale">
                            Sale
                        </div>
                        <div className="product_image">
                            <Link to="/shop-details">
                                <img src="/tm/react/toolways/assets/images/product/vegetables/17.png" className="image-fit-contain" alt="img"/>
                            </Link>
                            <ul className="social">
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-eye" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-cart-plus" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-cube" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fal fa-heart" aria-hidden="true"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <h4 className="title"><Link to="/shop-details">Best Grinder Tools</Link></h4>
                        <div className="price">
                            <span>$55.00</span>
                            <span>$80.25</span>
                        </div>
                        <div className="star-ratings">
                            <ul className="rating">
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star-half" aria-hidden="true"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star-half" aria-hidden="true"></i>
                                </li>
                            </ul>
                        </div>
                        <div className="product_action">
                            <button type="button" className="product_btn">ADD <i className="fal fa-plus"></i></button>
                        </div>
                    </div>
                </div>
                <div className="slide-item col-12">
                    <div className="product_block">
                        <div className="product_image">
                            <Link to="/shop-details">
                                <img src="/tm/react/toolways/assets/images/product/vegetables/18.png" className="image-fit-contain" alt="img"/>
                            </Link>
                            <ul className="social">
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-eye" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-cart-plus" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fa fa-cube" aria-hidden="true"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" data-tip="quick view">
                                        <i className="fal fa-heart" aria-hidden="true"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <h4 className="title"><Link to="/shop-details">Perceuse Filaire Tools</Link></h4>
                        <div className="price">
                            <span>$55.00</span>
                            <span>$80.25</span>
                        </div>
                        <div className="star-ratings">
                            <ul className="rating">
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star-half" aria-hidden="true"></i>
                                </li>
                                <li>
                                    <i className="fa fa-star-half" aria-hidden="true"></i>
                                </li>
                            </ul>
                        </div>
                        <div className="product_action">
                            <button type="button" className="product_btn">ADD <i className="fal fa-plus"></i></button>
                        </div>
                    </div>
                </div>
            </Slider>
        </div>
    </section>
    </>
  )
}

export default OurProductSlider